var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-2 rounded-full border-gray-800 h-12 w-12"})}
var staticRenderFns = []

export { render, staticRenderFns }